const translations: Record<string, string> = {
  "ak_bud2_incl_bess_effect_mn": "у т.ч. ефект УЗЕ {{v}} млн",
  "ak_bud2_segment_width_is_the_share_of_the_mont": "Ширина сегмента — частка від виручки місяця; відрахування починаються там, де закінчився попередній залишок.",
  "ak_bud2_break_even_revenue_mn_break_even_price": "БУ-виручка {{a}} млн · БУ-ціна BASE {{b}} грн/МВт·год",
  "ak_bud2_mn_of_mn": "{{a}} млн із {{b}} млн",
  "ak_bud2_folded_by_hour_of_day": "{{m}} · згорнуто по годині доби",
  "ak_bud2_uah_mwh": "грн/МВт·год",
  "ak_bud2_plan_release": "Відпуск плану",
  "ak_bud2_mwh": "{{v}} МВт·год",
  "ak_bud2_uah_mwh_2": "{{v}} грн/МВт·год",
  "ak_bud2_metric_hour": "Показник \\ Година",
  "ak_bud2_clock_hour": "Година астрономічна:",
  "ak_bud2_monthly_averages": "— середні за місяць;",
  "ak_bud2_totals": "— суми",
  "ak_bud2_for_of_days_that_have_an_hourly_plan": " за {{p}} із {{m}} діб, що мають погодинний план",
  "ak_bud2_so_total_differs_from_the_monthly_p_l": "тому «Всього» не дорівнює місячному плану P&L ({{mwh}} МВт·год / {{rev}} млн грн)",
  "ak_bud2_so_total_differs_from_the_monthly_p_l_2": "тому «Всього» не дорівнює місячному плану P&L ({{mwh}} МВт·год)",
  "ak_bud2_there_is_no_approved_budget_version_fo": "На цей місяць затвердженої версії бюджету немає.",
  "ak_bud2_uah_mn": "млн грн",
  "ak_bud2_revenue": "Виручка",
  "ak_bud2_variable_costs": "Змінні витрати",
  "ak_bud2_fixed_opex": "Фіксовані OPEX",
  "ak_bud2_finance_costs": "Фінансові витрати",
  "ak_bud2_income_tax": "Податок на прибуток",
  "ak_bud2_net_profit": "Чистий прибуток",
  "ak_bud2_loan_principal_repayment": "Погашення тіла кредиту",
  "ak_bud2_supplier_margin_3_imbalances_2_5": "маржа постачальника 3% + небаланси 2,5%",
  "ak_bud2_interest_fee_account_servicing": "проценти + комісія + РКО",
  "ak_bud2_cash_flow_after_repayment": "Потік після погашення",
  "ak_bud2_month_with_a_principal_payment_covered": "місяць із платежем тіла — покривається накопиченим потоком",
  "ak_bud2_from_revenue_to_cash_flow": "Від виручки до потоку",
  "ak_bud2_profitability_and_margin": "Рентабельність і запас",
  "ak_bud2_ebitda_margin": "Маржа EBITDA",
  "ak_bud2_net_margin": "Чиста маржа",
  "ak_bud2_safety_margin": "Запас прочності",
  "ak_bud2_bess_share_of_revenue": "Частка УЗЕ у виручці",
  "ak_bud2_source_monthly_slice_of_the_approved_a": "Джерело — місячний зріз затвердженого річного бюджету. Власну версію місяця з перерахунком на T−5/T−1 робить двигун (Ф3).",
  "ak_bud2_source_approved_version_of_the_monthly": "Джерело — затверджена версія бюджету місяця.",
  "ak_bud2_daily_profile_prices_and_release_plan": "Профіль доби: ціни та план відпуску",
  "ak_bud2_there_is_no_hourly_forecast_for_this_m": "Погодинного прогнозу на цей місяць у базі немає.",
  "ak_bud2_dam_price_forecast": "Ціна РДН (прогноз)",
  "ak_bud2_idm_price_forecast": "Ціна ВДР (прогноз)",
  "ak_bud2_total": "Всього",
  "ak_bud2_dam_price_uah_mwh": "Ціна РДН, грн/МВт·год",
  "ak_bud2_idm_price_uah_mwh": "Ціна ВДР, грн/МВт·год",
  "ak_bud2_plan_release_mwh": "Відпуск плану, МВт·год",
  "ak_bud2_bess_charge_mwh": "Заряд УЗЕ, МВт·год",
  "ak_bud2_bess_discharge_mwh": "Розряд УЗЕ, МВт·год",
  "ak_bud2_plan_revenue_uah_k": "Виручка плану, тис грн",
  "ak_bud2_mwh_2": "МВт·год",
  "ak_bud2_dam_price": "Ціна РДН",
  "ak_bud2_idm_price": "Ціна ВДР",
  "ak_bud2_prices": "Ціни",
  "ak_bud2_total_weighted_by_release_release_pric": " «Всього» = середньозважена відпуском (відпуск × ціна = виручка)",
  "ak_bud2_total_simple_daily_average_as_there_is": " «Всього» = проста середня за добу, бо плану відпуску для зважування немає",
  "ak_bud2_volumes_and_revenue": "Обсяги й виручка",
  "ak_bud2_for_the_month": " за місяць",
  "ak_bud2_there_is_no_hourly_release_plan_for_th": "погодинного плану відпуску на цей місяць ще немає — його дасть модель М1",
  "ak_bud2_comparable_both_plan_and_actual": "Зіставно (є і план, і факт):",
  "ak_bud2_days": "діб,",
  "ak_bud2_plan": "план",
  "ak_bud2_actual": "факт",
  "ak_bud2_total_of_actuals_across_all": "«Всього» факту — за всі",
  "ak_bud2_days_with_actuals": "діб із фактом",
  "ak_bud2_below_20_a_reason_from_the_dispatcher": "нижче −20%: {{days}} — потрібна причина від диспетчера",
  "ak_bud2_target": "ціль {{t}}",
  "ak_bud2_horizon_days": "горизонт {{h}} · {{d}} діб",
  "ak_bud2_profile_correlation_and_nmae_are_calcu": "Кореляція профілю {{c}} і nMAE {{n}} рахуються проти номінації — {{note}}. Для оцінки моделі тут значущі лише добові метрики вище.",
  "ak_bud2_base_uah_mwh": "BASE {{v}} грн/МВт·год",
  "ak_bud2_dip_11_16_forecast_actual": "«Яма» 11–16: прогноз {{p}} → факт {{f}} ({{e}})",
  "ak_bud2_peak_18_23_forecast_actual": "«Пік» 18–23: прогноз {{p}} → факт {{f}} ({{e}})",
  "ak_bud2_hours_volume_price_profile": "{{h}} годин · обсяг × ціна × профіль",
  "ak_bud2_mn": "{{v}} млн",
  "ak_bud2_mwh_uah_weighted": "{{a}} МВт·год × {{b}} грн (зважено)",
  "ak_bud2_days_channel_a_export": "{{d}} діб · канал A− (віддача)",
  "ak_bud2_pv_generation_ktp_meters": "Виробіток PV ({{n}} лічильники КТП)",
  "ak_bud2_bess_discharge_meters": "Віддача УЗЕ ({{n}} лічильники)",
  "ak_bud2_is_assumed_in_the_calculations": "у розрахунках закладено {{v}}",
  "ak_bud2_channel_a_import_is_absent_from_the_ex": "Канал A+ (надходження) у вивантаженні відсутній, тож чистий заряд не виміряний. Справжній коефіцієнт НИЖЧИЙ за показану межу — у залишку сидять ще власні потреби й втрати.",
  "ak_bud2_plan_actual_mwh": "план {{a}} → факт {{f}} МВт·год",
  "ak_bud2_definition_of_actuals": "Визначення факту: {{d}}",
  "ak_bud2_plan_vs_actual_by_day": "План-факт по днях",
  "ak_bud2_plan_accepted_mms_nomination_actual_gr": "план — прийнята номінація MMS · факт — відпуск у мережу",
  "ak_bud2_no_data_for_this_month": "За цей місяць даних немає.",
  "ak_bud2_mms_plan_mwh": "План MMS, МВт·год",
  "ak_bud2_actual_export_mwh": "Факт відпуску, МВт·год",
  "ak_bud2_deviation": "Відхилення, %",
  "ak_bud2_dam_price_actual_uah_mwh": "Ціна РДН факт, грн/МВт·год",
  "ak_bud2_actual_revenue_uah_k": "Виручка факту, тис грн",
  "ak_bud2_x": "Δ, %",
  "ak_bud2_deviation_2": "Відхилення",
  "ak_bud2_mms_plan": "План MMS",
  "ak_bud2_actual_2": "Факт",
  "ak_bud2_actual_export": "Факт відпуску",
  "ak_bud2_metric_day": "Показник \\ Доба",
  "ak_bud2_spec_thresholds_5_5_20_below_20": "пороги ТЗ: 🟢 ≥ −5% · 🟡 −5…−20% · ⚠ нижче −20%",
  "ak_bud2_there_are_no_forecast_actual_pairs_for": "За цей місяць немає пар «прогноз — факт» для розрахунку точності.",
  "ak_bud2_generation_forecast_accuracy": "Точність прогнозу генерації",
  "ak_bud2_hit_rate_10_tolerance": "Попадання (допуск 10%)",
  "ak_bud2_bias": "Зсув (bias)",
  "ak_bud2_systematic_over_under_estimation": "систематична пере/недооцінка",
  "ak_bud2_price_forecast_accuracy": "Точність прогнозу цін",
  "ak_bud2_hit_rate_15_tolerance": "Попадання (допуск 15%)",
  "ak_bud2_nmae_vs_base": "nMAE (від BASE)",
  "ak_bud2_profile_correlation": "Кореляція профілю",
  "ak_bud2_revenue_difference_breakdown": "Розкладання різниці виручки",
  "ak_bud2_revenue_per_plan": "Виручка за планом",
  "ak_bud2_revenue_per_actual": "Виручка за фактом",
  "ak_bud2_difference": "Різниця",
  "ak_bud2_volume_effect": "Ефект обсягу",
  "ak_bud2_profile_effect": "Ефект профілю",
  "ak_bud2_price_effect": "Ефект ціни",
  "ak_bud2_actual_plan_weighted_plan_price": "(факт − план) × зважена ціна плану",
  "ak_bud2_shifting_export_to_other_hours_the_mon": "перенос відпуску в інші години — грошовий ефект УЗЕ",
  "ak_bud2_market_deviation_from_the_forecast": "відхилення ринку від прогнозу",
  "ak_bud2_bess_charge_for_the_month": "Заряд УЗЕ за місяць",
  "ak_bud2_bess_discharge_for_the_month": "Розряд УЗЕ за місяць",
  "ak_bud2_this_shift_is_what_produces_the_profil": "саме цей перенос і дає ефект профілю",
  "ak_bud2_breakdown_residual": "Нев'язка розкладання",
  "ak_bud2_check_sum_of_the_three_effects_revenue": "контроль: сума трьох ефектів = різниця виручок",
  "ak_bud2_balance_by_askoe_meters": "Баланс за лічильниками АСКОЕ",
  "ak_bud2_grid_export_commercial_110_kv": "Відпуск у мережу (комерційний 110 кВ)",
  "ak_bud2_this_is_the_revenue_basis": "це і є база виручки",
  "ak_bud2_backup_meter": "Дублюючий лічильник",
  "ak_bud2_deviation_from_the_main_meter_should_b": "розходження з основним має бути в межах 1%",
  "ak_bud2_verification_10_kv": "Верифікаційний 10 кВ",
  "ak_bud2_balance_residual": "Залишок балансу",
  "ak_bud2_bess_charge_auxiliary_consumption_loss": "заряд УЗЕ + власні потреби + втрати",
  "ak_bud2_charge_coefficient_upper_limit": "Коефіцієнт заряду, верхня межа",
  "ak_bud2_days_with_the_largest_generation_forec": "Доби з найбільшою помилкою прогнозу генерації",
  "ak_bud2_top_5_by_absolute_deviation": "топ-5 за модулем відхилення",
  "ak_bud2_first_three_months_observation_then_th": "перші три місяці — спостереження, далі цілі стають KPI підрядників прогнозу",
  "ak_bud2_mms_nomination": "номінація MMS",
  "ak_bud2_engine_plan": "план двигуна",
  "ak_bud2_failed_to_save_http": "Не вдалося зберегти: HTTP {{s}}",
  "ak_bud2_failed_http": "Не вдалося: HTTP {{s}}",
  "ak_bud2_source": "джерело: {{s}}",
  "ak_bud2_buffer_mn_large_loan_principal": "буфер {{b}} млн (велике тіло кредиту)",
  "ak_bud2_buffer_mn": "буфер {{b}} млн",
  "ak_bud2_without_an_opening_balance_the_cash_fo": "Без стартового залишку прогноз каси не рахується. Виписки немає — введіть залишок на {{d}} вручну:",
  "ak_bud2_save": "Зберегти",
  "ak_bud2_forecast_balance_falls_below_the_buffe": "Прогнозний залишок падає нижче буфера {{b}} млн:",
  "ak_bud2_mn_2": "{{d}} → {{v}} млн",
  "ak_bud2_treasurer_decision_required_postpone_t": "Потрібне рішення казначея: перенос платежу, овердрафт або дострокова реалізація.",
  "ak_bud2_items": "{{n}} позицій · {{m}}",
  "ak_bud2_receipts_by_the_ten_day_rule_1_10_15th": "Надходження — за правилом декад (1–10 → 15-го, 11–20 → 25-го, 21–кінець → 5-го наступного), за вирахуванням маржі постачальника.",
  "ak_bud2_payment_days_of_the_fixed_items_are_no": "Дні оплати фіксованих статей у довіднику не заповнені — прийнято {{d}}-те число; це припущення, а не дані (ТЗ A7).",
  "ak_bud2_rows_to_confirm_unmatched": "{{n}} рядків · на підтвердження {{c}} · незіставлено {{u}}",
  "ak_bud2_no_statements_ingest_is_implemented_fo": "Виписок немає. Інжест реалізований під CSV",
  "ak_bud2_with_protection_against_re_upload_and": "із захистом від повторного завантаження і авто-зіставленням за правилами.",
  "ak_bud2_it_is_adapted_to_the_real_bank_format": "Під реальний формат банку (CSV / XML / MT940) адаптується заміною парсера — потрібен сам формат і спосіб отримання.",
  "ak_bud2_spec_b5_1_thresholds_confidence_0_90_a": "Пороги ТЗ B5.1: впевненість ≥ 0,90 — автоматично, 0,60–0,90 — на підтвердження, нижче — незіставлено. Пара купівлі валюти згортається в одну подію платежу банку й завжди йде на підтвердження казначею разом із фактичним курсом.",
  "ak_bud2_table": "Таблиця",
  "ak_bud2_and_the_matching_chain_are_ready_the_e": "і ланцюг зіставлення готові; бракує вивантаження з системи обліку — у ТЗ вона позначена як «BAS / 1С — уточнити».",
  "ak_bud2_enter_the_opening_balance_amount": "Введіть суму стартового залишку",
  "ak_bud2_failed_to_save_the_opening_balance": "Не вдалося зберегти стартовий залишок",
  "ak_bud2_failed_to_update_the_matching": "Не вдалося оновити зіставлення",
  "ak_bud2_opening_balance": "Стартовий залишок",
  "ak_bud2_no_statement_and_no_manual_value": "немає виписки й ручного значення",
  "ak_bud2_receipts": "Надходження",
  "ak_bud2_by_ten_day_periods_minus_margin": "за декадами, мінус маржа",
  "ak_bud2_payments": "Платежі",
  "ak_bud2_loan_opex_imbalances": "кредит, OPEX, небаланси",
  "ak_bud2_net_for_the_month": "Нетто за місяць",
  "ak_bud2_end_of_month": "На кінець місяця",
  "ak_bud2_mn_3": "млн",
  "ak_bud2_uah": "грн",
  "ak_bud2_payment_calendar": "Платіжний календар",
  "ak_bud2_date": "Дата",
  "ak_bud2_item": "Стаття",
  "ak_bud2_amount_uah": "Сума, грн",
  "ak_bud2_balance_after": "Залишок після",
  "ak_bud2_basis": "Основа",
  "ak_bud2_payment_day_assumed": "день оплати припущено",
  "ak_bud2_bank_operations_and_matching": "Операції банку та зіставлення",
  "ak_bud2_no_statements_uploaded_yet": "виписок ще не завантажено",
  "ak_bud2_counterparty": "Контрагент",
  "ak_bud2_purpose": "Призначення",
  "ak_bud2_conf": "Впевн.",
  "ak_bud2_status": "Стан",
  "ak_bud2_automatic": "автоматично",
  "ak_bud2_to_confirm": "на підтвердження",
  "ak_bud2_confirmed": "підтверджено",
  "ak_bud2_rejected": "відхилено",
  "ak_bud2_unmatched": "незіставлено",
  "ak_bud2_confirm_the_match": "Підтвердити зіставлення",
  "ak_bud2_confirm": "Підтвердити",
  "ak_bud2_reject_the_match": "Відхилити зіставлення",
  "ak_bud2_reject": "Відхилити",
  "ak_bud2_accounts_payable": "Кредиторська заборгованість",
  "ak_bud2_awaiting_access_to_accounting": "очікує доступу до бухгалтерії",
  "ak_bud2_accrued_per_acts_versus_paid_per_state": "Нараховано за актами проти оплачено за виписками, у розрізі контрагентів і договорів.",
};

export default translations;
